import $ from 'jQuery';

import submitForm from './modules/submit-form';
import cookies from './modules/cookies';
import jakte from './modules/jakte';
import sentry from './modules/sentry';
import ProjectSlider from './modules/project-slider';
import FormStyling from './modules/form-styling';
import RangeSlider from './modules/range-slider';
import GeminiSlider from './modules/gemini-slider';
import Header from './modules/header';
import ScrollTo from './modules/scroll-to';
import Animation from './modules/animation';
import VelaSlider from './modules/vela-slider';
import CepheusSlider from './modules/cepheus-slider';
import Filter from './modules/filter';
import Map from './modules/map';
import 'styles/less/application';

$(document).ready(() => {
  Map.init();
  cookies.init();
  sentry.init();
  jakte.init();
  submitForm.init();
  FormStyling.init();
  ProjectSlider.init();
  RangeSlider.init();
  GeminiSlider.init();
  Header.init();
  ScrollTo.init();
  Animation.init();
  VelaSlider.init();
  CepheusSlider.init();
  Filter.init();
});



// WEBPACK FOOTER //
// ./src/static/js/main.js